import { render } from "./DetailSerieCreate.vue?vue&type=template&id=6117b44a&scoped=true"
import script from "./DetailSerieCreate.vue?vue&type=script&lang=js"
export * from "./DetailSerieCreate.vue?vue&type=script&lang=js"

import "./DetailSerieCreate.vue?vue&type=style&index=0&id=6117b44a&lang=scss&scoped=true"
import "./DetailSerieCreate.vue?vue&type=style&index=1&id=6117b44a&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6117b44a"]])

export default __exports__